import { memo, useContext } from 'react'

import NoResults from './noResults'
import Loader from './loader'
import Card from './Card'
import { Column } from 'components/v2/Grid'
import TimezoneContext from 'context/timezoneContext'

const Results = ({
  psychologists,
  query,
  filters,
  shouldSpecifyLocationOnMoreFilters,
  isLoadingPsychologists,
  hasMorePsychologistsToLoad,
  onNavigateToPsychologist,
  onPaginatePsychologists,
  isFirstConsultation,
  isUserB2B,
  promotionalCoupon,
  accessibleConsultationBanner,
  timezone
}) => {
  return (
    <section id='results' style={{ background: '#f8f8f8', padding: '1px 0' }}>
      {psychologists?.length === 0 && !isLoadingPsychologists && <NoResults />}
      {psychologists?.length > 0 && (
        <Column className='flex-column container no-padding-mobile' px='0px !important'>
          <div className='no-padding-mobile'>
            {psychologists?.map(psychologist => (
              <Card
                key={psychologist.id}
                psychologist={psychologist}
                timezone={timezone}
                query={query}
                onNavigateToPsychologist={onNavigateToPsychologist}
                filters={filters}
                isFirstConsultation={isFirstConsultation}
                isUserB2B={isUserB2B}
                promotionalCoupon={promotionalCoupon}
                accessibleConsultationBanner={accessibleConsultationBanner}
              />
            ))}
          </div>
        </Column>
      )}
      {isLoadingPsychologists && <Loader text='Aguarde enquanto carregamos resultados ...' />}
      {shouldSpecifyLocationOnMoreFilters && (
        <p style={{ marginBottom: 32 }}>
          Preencha o campo 'Onde você está?' para encontrarmos psicólogos próximos a você :)
        </p>
      )}
      {hasMorePsychologistsToLoad && !isLoadingPsychologists && (
        <div className='container'>
          <div className='row' style={{ marginBottom: 32 }}>
            <div className='col-12 text-center'>
              <button
                style={{ cursor: 'pointer' }}
                type='button'
                className='button-verm'
                onClick={onPaginatePsychologists}
                disabled={isLoadingPsychologists || !hasMorePsychologistsToLoad}
                id='see-more-professionals'
              >
                Ver mais
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  )
}

export default memo(Results, (prev, next) => JSON.stringify(prev) === JSON.stringify(next))
